import { MapContainer, TileLayer } from 'react-leaflet'
import { DashboardAsset } from '../../../types/Dashboard'
import { AssetMarker } from './AssetMarker'
import 'leaflet/dist/leaflet.css'

type DashboardMapProps = {
    assets: DashboardAsset[]
    onSelectAsset: (id: number) => void
}

export function DashboardMap({ assets, onSelectAsset }: DashboardMapProps) {
    return (
        <MapContainer
            center={[54.0, -2.0]}
            zoom={6}
            className="dashboard-map"
        >
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {assets.map(asset => (
                <AssetMarker
                    key={asset.id}
                    asset={asset}
                    onClick={() => onSelectAsset(asset.id)}
                />
            ))}
        </MapContainer>
    )
}
